export const environment = {
  production: true,
  name: 'prod',
  versionCheckURL: "https://web.intercambioexpress.com",
  apiBaseUrl: 'https://web.intercambioexpress.com',
  apiBaseUrlRes: 'https://web.intercambioexpress.com',
  registerCardBaseUrl: 'https://demo.intercambioexpress.com',
  cardVerificationBaseUrl: 'https://crgw.intercambioexpress.com/api/registration',
  mapKey: 'AIzaSyCYdKzzyzEaf33Z9Xnh4zFRqRMCpi1TVIw',
  baseImageURLPort: '/9008', 
  FraudDetectionServicePort: '/9001',
  loginServicePort: '/9006',
  forgot_pass_soap_urlPort: '/9003',
  shareCodeURLPort: '/9005',
  messageCenterserviceURLPort: '/9004',
  ICEUserMgmtServicePort: '/9010',
  BeneficiaryServicePort: '/9002',
  ICEStoreLocatorServicePort: '/9009',
  ICEMasterServicePort: '/9008',
  AgentManagementServicePort: '/9011',
  getBranchesServicePort: '/9011',
  get_debit_card_urlPort: '/9013',
  add_debit_card_urlPort: '/9013',
  get_saved_stores_urlPort: '/9013',
  OrderProcessingServicePort: '/9012',
  CartActionItemServicesPort: '/9012',
  orderReceiptURLPort: '/9012',
  transactionServicePort: '/9012',
  ICEDocumentMgmtPort: '/9007',
  baseContentURLPort: '/9007',
  GetMyIPServicePort: '/9008',
  GetCardImageURLPort: '/9008',
  IdleTimeInSec: 3000
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts